import React, { createContext, useContext, useState, useCallback } from "react";

interface ResendEmailModalContextValue {
  isResendEmailModalOpen: boolean;
  setResendEmailModalOpen: (open: boolean) => void;
}

const ResendEmailModalContext = createContext<ResendEmailModalContextValue | null>(null);

export const useResendEmailModal = () => {
  const ctx = useContext(ResendEmailModalContext);
  if (!ctx) {
    throw new Error("useResendEmailModal must be used within ResendEmailModalProvider");
  }
  return ctx;
};

interface ResendEmailModalProviderProps {
  children: React.ReactNode;
}

export const ResendEmailModalProvider: React.FC<ResendEmailModalProviderProps> = ({
  children,
}) => {
  const [isResendEmailModalOpen, setResendEmailModalOpen] = useState(false);
  const setOpen = useCallback((open: boolean) => setResendEmailModalOpen(open), []);
  return (
    <ResendEmailModalContext.Provider
      value={{ isResendEmailModalOpen, setResendEmailModalOpen: setOpen }}
    >
      {children}
    </ResendEmailModalContext.Provider>
  );
};
